<template>
  <v-form ref="listProjectForm">
    <v-container>
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="pb-0">
          <div class="d-flex" v-if="filterBadge.length > 0">
            <v-chip small class="mr-2" v-for="(text, index) in filterBadge" :key="index">{{text}}</v-chip>
          </div>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" :class="[$vuetify.breakpoint.mdAndDown ? 'text-left' : 'text-right']">
          <v-btn v-if="$checkRight(['edit_project'])" :to="'project/create'" class="primary" small>Add</v-btn>
          <v-btn @click="deactiveProject" class="ml-2" small color="#eee" v-if="$checkRight(['delete_project'])">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn @click="openDrawer = !openDrawer" class="ml-2" small color="#eee">
            <v-icon small>mdi-filter</v-icon>
          </v-btn>
          <v-btn @click="clearFilter(false);$refreshDataTable()" class="ml-2" small color="#eee">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Datatable -->
      <datatable
        ref="project_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
        :filterColumn="filterColumn"
      />
      <!-- Filter -->
      <popup-drawer :value.sync="openDrawer" :openDrawer="openDrawer">
        <v-col cols="12">
          <v-text-field
            placeholder="Project No"
            label="Project No"
            v-model="filter.serial_no"
            autofocus
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.start_date_from_date"
            type="date"
            placeholder="From Start Date"
            label="From Start Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.start_date_to_date"
            type="date"
            placeholder="To Start Date"
            label="To Start Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.end_date_from_date"
            type="date"
            placeholder="From End Date"
            label="From End Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="filter.end_date_to_date"
            type="date"
            placeholder="To End Date"
            label="To End Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            placeholder="Description"
            label="Description"
            v-model="filter.description"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            clearable
            return-object
            item-value="id"
            label="Status"
            placeholder="Status"
            v-model="filter.status"
            :items="[{id: 'pending', text: 'Pending', color: 'orange'}, {id: 'open', text: 'Open', color: 'green'}, {id: 'approved', text: 'Approved', color: 'primary'}, {id: 'complete', text: 'Complete', color: 'secondary'}, {id: 'in_active', text: 'Inactive', color: '#FFC107'}]"
            :small-chips="true">
            <template #selection="{ item }">
              <v-chip :color="item.color" small>{{item.text}}</v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn @click="filterData" class="mt-4" color="primary" small>Filter</v-btn>
          <v-btn @click="clearFilter" class="mt-4 ml-2" small>Clear</v-btn>
        </v-col>
      </popup-drawer>
    </v-container>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  computed: {
    filterBadge () {
      const fList = []
      Object.keys(this.filterDisplay).map((x, i) => {
        if (typeof this.filterDisplay[x] === 'object') {
          fList.push(this.filterDisplay[x].text)
        } else if (this.filterDisplay[x]) {
          fList.push(this.filterDisplay[x])
        }
      })
      return fList
    }
  },
  created () {
    if (!this.$checkRight(['edit_project']) && !this.$checkRight(['delete_project'])) {
      this.tableOption.headers.shift()
    }
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      tableOption: {
        url: 'getProjectAll',
        editUrl: 'project/edit',
        deleteRoute: 'deactiveProject',
        moduleName: 'project',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80, removeDeleteBtn: true },
          { text: 'Project No', value: 'serial_no' },
          { text: 'Start Date', value: 'start_date' },
          { text: 'End Date', value: 'end_date' },
          { text: 'Description', value: 'description' },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          pending: { color: 'orange', text: 'Pending' },
          open: { color: 'green', text: 'Open' },
          approved: { color: 'primary', text: 'Approved' },
          complete: { color: 'secondary', text: 'Complete' },
          in_active: { color: '#FFC107', text: 'Inactive' },
        }
      },
      filterColumn: {
        start_date: { format: '' },
        estimated_end_date: { format: '' },
        end_date: { format: '' }
      },
      openDrawer: false,
      filter: {},
      filterDisplay: {}
    }
  },
  watch: {
    options: {
      handler () {
      },
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactiveProject () {
      this.$refs.project_datatable.massDeleteTableData()
    },
    filterData () {
      this.$eventBus.$emit('$filterDataTable', this.filter)
      this.openDrawer = false
      this.filterDisplay = this.filter ? JSON.parse(JSON.stringify(this.filter)) : {}
    },
    clearFilter (callEmit = true) {
      if (callEmit) {
        this.$eventBus.$emit('$filterDataTable', {})
      }
      this.openDrawer = false
      this.filter = {}
      this.filterDisplay = {}
    }
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
/* .v-data-table-header > tr > th:first-child{
  background: red;
} */
</style>
